import React from 'react';
import ChatSupport from './ChatSupport';
import WhatsAppSupport from './WhatsAppSupport';
import PhoneSupport from './PhoneSupport';
import TicketSupport from './TicketSupport';

const SupportContent = ({ selectedSupport }) => {
  const renderSupportContent = () => {
    switch (selectedSupport) {
      case 'chat':
        return <ChatSupport />;
      case 'whatsapp':
        return <WhatsAppSupport />;
      case 'phone':
        return <PhoneSupport />;
      case 'ticket':
        return <TicketSupport />;
      default:
        return <ChatSupport />;
    }
  };

  return (
    <div className="bg-gray-800 rounded-2xl p-8">
      {renderSupportContent()}
    </div>
  );
};

export default SupportContent;